import encryptDecrypt from '../../cryptography/encryptDecrypt';
import config from '../../../config/config';
import moment from 'moment';
import bulkExpressionParser from '../simpleScript/expressionParser/bulkExpressionParser';
import dotNotationMapper from '../../data/dotNotationMapper';
import validator from 'validator';

export default async function(
    functionObj={},
    variableObject={},
    parameterObject={},
    functionMap={},
    variableIdMap={}
){
    try{
        const {
            executionObject={}
        } = functionObj;
        const {
            variableName='', 
            variableUnavailable=false, 
        } = executionObject;
        const {
            companyId='', inhouz_reserved_parameters_xyzh={}
        } = parameterObject;
        const {appEnvironment=''} = inhouz_reserved_parameters_xyzh;

        if(!variableName || variableUnavailable){
            return {
                updatedVariableObject : variableObject,
                hasError : true,
                errorPayload : 'Variable name is missing.',
                hasReturnStatement : false,
                returnStatement : undefined
            }
        }

        let parsedParameters = await bulkExpressionParser({
            executionObject,
            variableObject,
            parameterObject,
            functionMap,
            variableIdMap,
            useAllFields : true
        });

        let variableCopy = parsedParameters['variableObject'];
        if(parsedParameters.error){
            variableCopy[variableName] = {
                error : {
                    message : 'Failed to parse function data.'
                }
            }
            return {
                updatedVariableObject : variableCopy,
                hasError : true,
                errorPayload : 'Failed to resolve function parameters.',
                hasReturnStatement : false,
                returnStatement : undefined
            }
        }

        let resolvedParams = parsedParameters['accumulator'];

        let userList = resolvedParams['userList'] || [];
        if(
            !Array.isArray(userList) ||
            (userList.length === 0)
        ){
            variableCopy[variableName] = {
                error : {
                    message : 'Invalid user list.'
                }
            }
            return {
                updatedVariableObject : variableCopy,
                hasError : true,
                errorPayload : 'Invalid user list.',
                hasReturnStatement : false,
                returnStatement : undefined
            }
        }

        let signupUserFormUsers = [];
        for (let i = 0; i < userList.length; i++){
            let userObj = userList[i];
            let signupUser = {
                firstName : dotNotationMapper(userObj, resolvedParams['firstNameField']) || '',
                lastName : dotNotationMapper(userObj, resolvedParams['lastNameField']) || '',
                email : dotNotationMapper(userObj, resolvedParams['emailField']) || '',
                dob : dotNotationMapper(userObj, resolvedParams['dobField']) || '',
                sex : dotNotationMapper(userObj, resolvedParams['sexField']) || '',
                isAdmin : dotNotationMapper(userObj, resolvedParams['isAdminField']) === true ? true : false,
            }

            if(
                !validator.isEmail(signupUser['email'])
            ){
                continue;
            }else{
                signupUserFormUsers.push(signupUser);
            }
        }

        if(signupUserFormUsers.length === 0){
            variableCopy[variableName] = {
                error : {
                    message : 'Missing valid external users.'
                }
            }
            return {
                updatedVariableObject : variableCopy,
                hasError : true,
                errorPayload : 'Missing valid external users.',
                hasReturnStatement : false,
                returnStatement : undefined
            }
        }

        if(!resolvedParams['X-API-KEY']){
            variableCopy[variableName] = {
                error : {
                    message : 'API key is missing.'
                }
            }
            return {
                updatedVariableObject : variableCopy,
                hasError : true,
                errorPayload : 'API key is missing.',
                hasReturnStatement : false,
                returnStatement : undefined
            }
        }

        if(!resolvedParams['companyId']){
            variableCopy[variableName] = {
                error : {
                    message : 'Company ID is required.'
                }
            }
            return {
                updatedVariableObject : variableCopy,
                hasError : true,
                errorPayload : 'Company ID is required.',
                hasReturnStatement : false,
                returnStatement : undefined
            }
        }

        if(!resolvedParams['subscriptionServiceId']){
            variableCopy[variableName] = {
                error : {
                    message : 'subscriptionServiceId is required.'
                }
            }
            return {
                updatedVariableObject : variableCopy,
                hasError : true,
                errorPayload : 'subscriptionServiceId is required.',
                hasReturnStatement : false,
                returnStatement : undefined
            }
        }

        if(!resolvedParams['subscriptionServiceTierId']){
            variableCopy[variableName] = {
                error : {
                    message : 'subscriptionServiceTierId is required.'
                }
            }
            return {
                updatedVariableObject : variableCopy,
                hasError : true,
                errorPayload : 'subscriptionServiceTierId is required.',
                hasReturnStatement : false,
                returnStatement : undefined
            }
        }

        let clientEncryptedApiHeader = encryptDecrypt(
            JSON.stringify({
                payload : {
                    'X-API-KEY' : resolvedParams['X-API-KEY'],
                    companyId,
                    queryKey : `${Math.random()}${Math.random()}${Math.random()}${new Date().getTime()}`,
                    environment : appEnvironment
                },
                expirationTimestamp : moment().add(1000, 'seconds').unix() * 1000
            }),
            true
        );

        let payload = {
            signupUserFormUsers,
            assetOwnerCompanyId : companyId,
            companyId : resolvedParams['companyId'],
            subscriptionServiceId : resolvedParams['subscriptionServiceId'],
            subscriptionServiceTierId : resolvedParams['subscriptionServiceTierId'],
            webhookMetadata : resolvedParams['webhookMetadata'] || {},
            functionGenerated : true
        }

        let encryptedPayload = encryptDecrypt(JSON.stringify({
            payload,
            expirationTimestamp : moment().add(5, 'minutes').unix() * 1000
        }))

        let response = await fetch(
            `${config.devServerProxy}/api/subscribe/automatedexternalsignup`,
            {
                method : 'POST',
                headers : {
                    'Accept':"application/json",
                    'Content-Type':"application/json",
                    'Cache': 'no-cache',
                    'X-CE-API-KEY' : clientEncryptedApiHeader
                },
                credentials : 'omit',
                body : JSON.stringify({encryptedPayload})
            }
        )
        .then(resp => resp.json())
        .catch((error) => {
            return {
                error : {
                    message : error.message
                }
            }
        });

        variableCopy[variableName] = response;
        return {
            hasError : false,
            errorPayload : undefined,
            hasReturnStatement : false,
            returnStatement : undefined,
            updatedVariableObject : variableCopy
        }
    }catch(e){
        console.log('/utils/functionParser/general/functionTypeParser/addSubscriptionServiceExternalUserParser catch block error', e);
        return {
            updatedVariableObject : variableObject,
            hasError : true,
            errorPayload : e.stack,
            hasReturnStatement : false,
            returnStatement : undefined
        } 
    }
}